<template>
  <v-container class="home">
    <!-- <v-carousel
      class="mt-6"
      height="100%"
      cycle
      hide-delimiter-background
      :show-arrows="false"
      interval="10000"
      reverse-transition="fade-transition"
      transition="fade-transition"
    >
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <v-row>
          <v-img
            class="white--text align-end"
            :src="slide.src"
            contain
            max-height="700"
          >
          </v-img>

        </v-row>
      </v-carousel-item>
    </v-carousel>-->
    <vue-flux
      :options="vfOptions"
      :images="vfImages"
      :transitions="vfTransitions"
      :captions="vfCaptions"
    >
      <template v-slot:caption>
        <flux-caption />
      </template>
    </vue-flux>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { VueFlux, FluxCaption } from "vue-flux";

export default {
  components: {
    VueFlux,
    FluxCaption,
  },
  data() {
    return {
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4",
      ],
      slides: [
        {
          background: "indigo",
          src:
            "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fsunrise%2FP1022954-HDR.jpg?alt=media&token=3a49c80c-4003-4d89-a9f7-bf550ab1704e",
          title: "Sunrise",
          text1:
            "The best part of the day, quiet and peaceful, and when we have high clouds in the sky you can witness a spectacular display of colours. Make sure that you get up at least 30-40 minutes before the sunrise as that is usually the peak time to see deep reds, pretty pinks and bright yellows and oranges.",
        },
        {
          background: "warning",
          src:
            "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fsunset%2FP1034116-Pano.jpg?alt=media&token=9cb21c25-551a-467b-967e-44b019a6953d",
          title: "Sunset",
          text1:
            "After a busy day its great to sit with family and friends and watch the sun set in to the sea. As the last rays of light disappear over the horizon don't be tempted to leave as like the sunrise with the right conditions you may miss a beautiful specticle as the sun bounces off the clouds.",
        },
        {
          background: "pink darken-2",
          src:
            "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fdaytime%2FP1021962-Pano.jpg?alt=media&token=629724cc-0f4c-4bd4-8112-ecd62d50ce74",
          title: "St Ives by Day",
          text1:
            "St Ives has a number of beautiful beaches, when the tide is particularly low you can walk between some of the these without getting your feet wet. What better time to stand out side of the harbour walls and capture a panoramic shot of this wonderful town.",
        },
        {
          background: "red lighten-1",
          src:
            "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fnighttime%2FP1058522.jpg?alt=media&token=c8ba48a3-e495-41ec-9da2-571b2341683d",
          title: "St Ives by Night",
          text1:
            "After the sun has set the lights begin to shine in St Ives, the harbour is a hive of activity with people visiting resturants, pubs and late night shopping. Blue hour is the hour after sunset at this time a camera will still be able to pick up the glow on the horizon of the long departed sun.",
        },
        {
          background: "deep-purple accent-4",
          src:
            "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fcornwall%2FP1102442.jpg?alt=media&token=ee8084bb-6937-484a-b739-73a41adbbc7b",
          title: "Cornwall",
          text1:
            "There are many things to see in Cornwall including beaches, attaractions but the most spectacular is the rugged coast line. There are many coast footpaths that you can follow and explorer secluded coves, cliffs, old engine houses and shipwrecks.",
        },
        {
          background: "indigo",
          src:
            "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fevents%2FP1069110.jpg?alt=media&token=935a03e7-be27-438a-99a0-8fe8e7152def",
          title: "Events",
          text1:
            "During the summer months Cornwall is host to vaious Food and Drink, Beer and Music festivals. In May the Food and Drink Festival on Porthminster beach attracts people from all over the country. The three day festival is packed with tasty food, cooking demonstrations, entertainment and a firework display",
        },
        {
          background: "warning",
          src:
            "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Ffireworks%2FP1180577.jpg?alt=media&token=85223b8f-e92f-48d3-997f-970293b2a2d5",
          title: "Fireworks",
          text1:
            "If there are fireworks theres usually something to celebrate, Bonfire Night, Weddings or New Years I love a good firework display. St Ives at New Years has a big party atmosphere with everyone dressing up for the night and walking around town, at the stroke of night the fireworks are set off from Smeatons Pier and the new year begins with a bang.",
        },
      ],
      vfOptions: { autoplay: true },
      vfImages: [
        "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fsunrise%2FP1022954-HDR.jpg?alt=media&token=3a49c80c-4003-4d89-a9f7-bf550ab1704e",
        "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fsunset%2FP1034116-Pano.jpg?alt=media&token=9cb21c25-551a-467b-967e-44b019a6953d",
        "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fdaytime%2FP1021962-Pano.jpg?alt=media&token=629724cc-0f4c-4bd4-8112-ecd62d50ce74",
        "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fnighttime%2FP1058522.jpg?alt=media&token=c8ba48a3-e495-41ec-9da2-571b2341683d",
        "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fcornwall%2FP1102442.jpg?alt=media&token=ee8084bb-6937-484a-b739-73a41adbbc7b",
        "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Fevents%2FP1069110.jpg?alt=media&token=935a03e7-be27-438a-99a0-8fe8e7152def",
        "https://firebasestorage.googleapis.com/v0/b/tom-wedge-images.appspot.com/o/images%2Ffireworks%2FP1180577.jpg?alt=media&token=85223b8f-e92f-48d3-997f-970293b2a2d5",
      ],
      vfCaptions: [
        "Sunrise in St Ives bay",
        "Sunset on Porthmeor Beach, Fire in the Sky",
        "St Ives at low tide",
        "Harbour light reflections in the Blue Hour",
        "The rugged Cornish coastline between Sennen and Lands End",
        "St Ives Food and Drink Festival on Porthminister beach",
        "Seeing in the New Year with the annual firework display on Smeatons Pier",
      ],
      vfTransitions: ["waterfall"],
    };
  },
};
</script>
